module.exports = __webpack_public_path__ + "static/media/website-design-screen.8b879dc4.svg";